import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import isEmpty from 'lodash/isEmpty';
import get from "lodash/get";
import findLast from 'lodash/findLast';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FooterButtons from '../../components/Button/FooterButtons';
import AddressCard from '../../components/Address/AddressCard';
import AddEditCustomerAddress from '../../components/Address/AddEditCustomerAddress';
import PatientGenderCard from "../../components/PatientGenderCard/PatientGenderCard";
import './DeliveryAddress.scss';
import * as actions from '../../actions';
import * as Constants from '../../constants';
import PatientCard from '../../components/Patient/PatientCard';
import { Modal, ModalBody, ModalFooter } from 'react-modal-bootstrap';
import '../../components/DiagnosticsCart/GeneralModal.scss';
// import * as Validations from "../../utils/validations";
// import * as Helper from "../../utils/helper";


const enabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_enabled.svg';
const disabledRadio = 'https://pe-web-assets.s3.amazonaws.com/images/prescriptions/radio_button_disabled.svg';
const minimumAllowedAge = 1;
const allowedGenderValues = ['M', 'F', 'O'];
const genderCodeByLetter = { M: 1, F: 2, O: 3 };
const ageFieldError = 'Please enter a valid age';
const ageFieldErrorForCTA = 'Age of selected patient is not valid';
const genderFieldError = 'Please select a gender';
const genderFieldErrorForCTA = 'Gender of Selected patient is not mentioned';
const generalError = 'Please fill all fields';
const generalErrorForCTA = 'Please fill all the details of Selected patient';

class DiagnosticsDeliveryAddress extends Component {
  constructor(props) {
    super(props);
    this.fetchPatients();
    this.getAddresses();
    // this.props.actions.getRefillIntervals({ type: 'active' });
    this.state = {
      selectedPatient: {},
      selectedPatientToEdit: {},
      showAddPatientForm: false,
      newPatientDetails: {},
      selectedAddressId: '',
      errorMsg: '',
      selectedOption: -1,
      editAddressDetails: '',
      openErrorModal: true,
      showGenderPopup: false,
      genderConfirmed: false,
    };
  }

  componentWillMount() {
    this.setState(this.props.orderParams);
    this.props.actions.changeHeaderState(Constants.SELECT_ADDRESS);
  }
  setPatientProps = (key, value) => {
    if (!isEmpty(this.state.selectedPatientToEdit)) {
      const { selectedPatientToEdit: { id, tenantPatientId, name, age, gender } } = this.state;
      const patientDetails = {
        id,
        tenantPatientId,
        name,
        age,
        gender,
        [key]: value
      };
      this.setState({ selectedPatientToEdit: patientDetails });
    } else {
      const patientDetails = {
        ...this.state.newPatientDetails,
        [key]: value
      };
      this.setState({ newPatientDetails: patientDetails });
    }
  }

  getAddresses = () => {
    this.selectAddress({});
    this.props.actions.getAddresses().then(addressResp => {
      const pincodes = [];
      if (!isEmpty(addressResp.data)) {
        addressResp.data.forEach(item => pincodes.push(String(item.pincode)));
        // eslint-disable-next-line react/prop-types
        this.props.actions.getLabServiceability(pincodes, this.props.selectedLab.item_id)
          .then(labResponse => {
            const pincodeObj = labResponse.data.serviceability.find(pin => pin.is_pathlab_enabled && pin.is_serviceable);
            const address = addressResp.data.find(item => Number(item.pincode) === Number(pincodeObj.pincode));
            this.selectAddress(address);
          });
      }
    });
  }

  addPatient = () => {
    const addPatientObj = {
      patients: [{...this.state.newPatientDetails, gender: genderCodeByLetter[this.state.newPatientDetails.gender],}]
    };
    this.props.actions.addPatient(addPatientObj).then((resp) => {
      if (resp && resp.error && resp.error.message) {
        alert(resp.error.message);
        return;
      }
      this.fetchPatients();
      this.getAddresses();
      this.toggleAddPatientForm();
    });
  }

  fetchPatients = () => {
    this.setState({
      selectedPatientToEdit: {},
    });
    this.selectPatient({});
    this.props.actions.fetchPatients().then(resp => {
      if (!isEmpty(resp.data)) {
        this.selectPatient(resp.data[0]);
      }
    });
  }

  editPatient = () => {
      const patientToUpdate = {...this.state.selectedPatientToEdit, gender: genderCodeByLetter[this.state.selectedPatientToEdit.gender],};                                                                                                                    
      this.props.actions.updatePatient(patientToUpdate).then((resp) => {
        if (resp && resp.error && resp.error.message) {
          alert(resp.error.message);
          return;
        }
      this.fetchPatients();
      this.getAddresses();
      this.toggleAddPatientForm();
    });
  }

  editPatientClicked = patient => {
    this.setState({
      showAddPatientForm: true,
      selectedPatient: patient,
      selectedPatientToEdit: patient,
    });
  }

  toggleAddPatientForm = () => {
    this.setState({
      showAddPatientForm: !this.state.showAddPatientForm,
      selectedPatientToEdit: {},
      newPatientDetails: {}
    });
  }

  backToProducts = () => {
    this.props.actions.setOrderParams(this.state);
    browserHistory.push('/diagnostics/add-products');
  }

  selectAppointmentDate = () => {
    const { cartData } = this.props;
    const isPatientSelectionOnCart = get(cartData, 'is_patient_selection_on_cart', false);
    if (isEmpty(this.state.selectedPatient)) {
      alert('Please select patient details to proceed');
    } else if (!this.state.selectedAddressId) {
      alert('Please select sample pickup address details to proceed');
    } else if (isPatientSelectionOnCart && (!this.state.selectedGender || !this.state.genderConfirmed)) {
      this.setState({ showGenderPopup: true });
    } else {
      browserHistory.push('/diagnostics/review-order');
    }
  }
  handleGenderSelectProceed = () => {
    this.setState(
      {
        showGenderPopup: false,
        genderConfirmed: true,
      },
      () => {
        browserHistory.push('/diagnostics/review-order');
      }
    );
  };

  handleGenderPopupClose = () => {
    this.setState({ showGenderPopup: false });
  };

  handleGenderSelect = gender => {
    this.props.actions.setSelectedGender(gender);
  };

  cancelOrder = () => {
    if (confirm('Are you sure you want to cancel this order ?')) {
      this.props.actions.setLeadCx('');
      this.props.actions.cancelOrder();
      browserHistory.push('/customer-info');
    }
  }

  selectPatient = patient => {
    this.setState({ selectedPatient: patient, openErrorModal: true });
    this.props.actions.selectPatient(patient);
  }

  deletePatient = patient => {
    this.props.actions.deletePatient(patient.tenantPatientId).then(() => {
      this.fetchPatients();
      this.getAddresses();
    });
  }

  patientsContainerComp = () => {
    const { patientsList, patientsLoading } = this.props;
    const { selectedPatient } = this.state;
    return (<div className="PatientDetailsContainer">
      <div className="PatientDetailsTitle">Patient Details</div>
      <div className="selectPatientBtnWrapper">
        <span>
          <span className="selectPatientTitle">Select Patient</span>
          <span className="infoText">These details will appear on final test report</span>
        </span>
        <button onClick={this.toggleAddPatientForm} className="addNewPatientBtn">Add New Patient</button>
      </div>
      <div className="patientListWrapper">
        {patientsLoading && <div>Loading Patients...</div>}
        {isEmpty(patientsList) ? patientsLoading && <div className="error">No patient details found. Add a new patient details</div> : patientsList.map((patient, index) =>
          <PatientCard
            key={index}
            index={index}
            selectedPatient={selectedPatient}
            selectPatient={this.selectPatient}
            editPatientClicked={this.editPatientClicked}
            deletePatient={this.deletePatient}
            patientData={patient}
          />
        )}
      </div>
    </div>);
  }

  addNewAddressClicked = () => {
    this.setState({ editAddressDetails: '' });
    this.setState({ addnewAddressView: !this.state.addnewAddressView });
  }

  selectAddress = address => {
    this.setState({ selectedAddressId: address.id || '' });
    // this.highLightPayementOption();
    this.props.actions.selectAddress(address.id || '');
    this.props.actions.selectAddressDiagnostics(address);
  }

  editAddressClicked = details => {
    this.setState({ editAddressDetails: details });
    this.setState({ addnewAddressView: !this.state.addnewAddressView });
  }

  saveNewAddress = newAddress => {
    if (newAddress.id) {
      this.props.actions.editAddress(newAddress).then(() => {
        this.getAddresses();
        this.setState({ addnewAddressView: !this.state.addnewAddressView });
      });
    } else {
      this.props.actions.saveNewAddress(newAddress).then(() => {
        this.getAddresses();
        this.setState({ addnewAddressView: !this.state.addnewAddressView });
      });
    }
  }

  deleteAddress = id => {
    // const { selectedAddressId } = this.state;
    if (!confirm('Are you sure you want to delete this address.')) {
      return;
    }
    this.props.actions.deleteAddress(id).then(() => {
      this.getAddresses();
    });
  }

  addressDetailsComp = () => {
    const {
      addnewAddressView,
      selectedAddressId,
      errorMsg,
      editAddressDetails,
      openErrorModal,
      selectedPatient,
    } = this.state;

    const { addresses, patientsLoading, patientsList } = this.props;
    const { loading, action } = addresses;
    const patientValidationObj =
    !patientsLoading && patientsList.length > 0
      ? this.isSelectedPatientValid(selectedPatient)
      : { isValid: null, errorMessage: null };

    return (
      <div>
        <div className="DeliveryAddressHeader">
          <div className="DeliveryAddressHeaderText">
            {addnewAddressView ? 'Add Sample Pickup Address' : 'Sample Pickup Address'}
            <button onClick={this.addNewAddressClicked} className="addNewAddressBtn">
              {addnewAddressView ? 'Back to Saved Addresses' : 'Add New Address'}
            </button>
          </div>
        </div>
        {!addnewAddressView && <div className="DeliveryAddressesContainer">
          {isEmpty(addresses.data) ? <div className="error">No address found. Add new address</div> : addresses.data.map((address, index) => {
            const pincodeDetails = findLast(addresses.servicablePincodes, { pincode: String(address.pincode) }) || {};
            return (<AddressCard
              key={address.id}
              index={index}
              pincodeDetails={pincodeDetails}
              selectedAddressId={selectedAddressId}
              addressDetails={address}
              deleteAddress={this.deleteAddress}
              editAddressClicked={this.editAddressClicked}
              selectAddress={this.selectAddress}
              isDiagnosticsAddress
            />);
          })}
          {errorMsg && <div className="errorMsg">{errorMsg}</div>}
        </div>}
        {addnewAddressView &&
          <AddEditCustomerAddress
            action={action}
            loading={loading}
            addressDetails={editAddressDetails}
            saveNewAddress={this.saveNewAddress}
          />}
        {!addnewAddressView && <FooterButtons
          backBtnText="Back to Products"
          backBtnClick={() => this.backToProducts()}
          proceedBtnClick={() => this.selectAppointmentDate()}
          proceedBtnText="Select Appointment Date"
          cancelBtnClick={() => this.cancelOrder()}
          cancelBtnText="Cancel Order"
          nextStateAllowed={patientValidationObj.isValid !== false}
        />}
        { openErrorModal && patientValidationObj.isValid === false &&
          <Modal
            className="topLevelontainer"
            isOpen
            onRequestHide={this.handleCTA}
          >
            <ModalBody>
              <div>{patientValidationObj.errorMessage}</div>
            </ModalBody>
            <ModalFooter className="footer">
              <button className="btn greenBtn" onClick={this.handleCTA}>
                Ok
              </button>
            </ModalFooter>
          </Modal>
        }
      </div>
    );
  }

  handleCTA = () => {
    this.setState({
      openErrorModal: false,
    });
  }

  isSelectedPatientValid = selectedPatient => {
    const validationErrors = this.validatePatientData(selectedPatient);
    const errorMessage = this.getErrorMessageForProceedCTA(validationErrors);
    return { isValid: !errorMessage, errorMessage };
  };

  validatePatientData = patientData => {
    const hasGeneralError = (isEmpty(patientData) || isEmpty(patientData.name));
    const hasAgeError = (!isEmpty(patientData) && this.validateAge(String(patientData.age)));
    const hasGenderError = (!isEmpty(patientData) && this.validateGender(patientData.gender));
    return { hasGeneralError, hasAgeError, hasGenderError };
  };

  validateAge = age => {
    if (age && age.length && !!Number(age)) {
      const postDecimalValue = age.split('.')[1];
      const isValidPostDecimalValue = postDecimalValue ? Number(postDecimalValue) === 0 : true;
      const isValidAge = ((Number(age) >= minimumAllowedAge) && isValidPostDecimalValue);
      return !isValidAge;
    }
    return true;
  };

  validateGender = genderValue => !allowedGenderValues.includes(genderValue);

  getErrorMessageForForm = ValidationErrors => {
    if (ValidationErrors.hasGeneralError) {
      return generalError;
    } else if (ValidationErrors.hasAgeError) {
      return ageFieldError;
    } else if (ValidationErrors.hasGenderError) {
      return genderFieldError;
    }
    return null;
  }

  getErrorMessageForProceedCTA = ValidationErrors => {
    if (ValidationErrors.hasGeneralError) {
      return generalErrorForCTA;
    } else if (ValidationErrors.hasAgeError) {
      return ageFieldErrorForCTA;
    } else if (ValidationErrors.hasGenderError) {
      return genderFieldErrorForCTA;
    }
    return null;
  }

  addNewPatientComp = () => {
    const { newPatientDetails, selectedPatientToEdit } = this.state;
    const patientData = isEmpty(selectedPatientToEdit) ? newPatientDetails : selectedPatientToEdit;
    const validationErrors = this.validatePatientData(patientData);
    const errorMessage = this.getErrorMessageForForm(validationErrors);
    return (<div className="AddPatientContainer">
      <div className="AddPatientTitle">
        <span>Add Patient Details</span>
        <span className="goBackBtn" onClick={this.toggleAddPatientForm}>&lt;&lt; Go Back</span>
      </div>
      <div className="patientFormItemWrapper">
        <div className="patientFormFieldTitle">Full Name</div>
        <input
          type="text"
          className="patientFormFieldInput"
          required
          placeholder="Placeholder"
          value={!isEmpty(selectedPatientToEdit) ? selectedPatientToEdit.name || '' : patientData.name}
          pattern="[a-zA-Z][a-zA-Z ]*"
          onChange={event => this.setPatientProps('name', event.target.value)}
        />
      </div>
      <div className="yearGenderWrapper">
        <div className="patientFormItemWrapper">
          <div className="patientFormFieldTitle">Age</div>
          <input
            type="number"
            className="patientFormFieldInput"
            placeholder="e.g. 30"
            value={!isEmpty(selectedPatientToEdit) ? selectedPatientToEdit.age || '' : patientData.age}
            required
            pattern="[0-9]{2}"
            onChange={event => this.setPatientProps('age', Number(event.target.value))}
          />
        </div>
        <div className="patientFormItemWrapper">
          <div className="patientFormFieldTitle">Gender</div>
          <div className="genderBtns">
            <div className="genderOptionContainer" onClick={() => this.setPatientProps('gender', 'M')}>
              <img
                className="genderRadioBtn"
                alt=""
                src={newPatientDetails.gender === 'M' || selectedPatientToEdit.gender === 'M' ?
                  enabledRadio : disabledRadio}
              />
              <span>Male</span>
            </div>
            <div className="genderOptionContainer" onClick={() => this.setPatientProps('gender', 'F')}>
              <img
                className="genderRadioBtn"
                alt=""
                src={newPatientDetails.gender === 'F' || selectedPatientToEdit.gender === 'F' ?
                  enabledRadio : disabledRadio}
              />
              <span>Female</span>
            </div>
            <div className="genderOptionContainer" onClick={() => this.setPatientProps('gender', 'O')}>
              <img
                alt=""
                className="genderRadioBtn"
                src={newPatientDetails.gender === 'O' || selectedPatientToEdit.gender === 'O' ?
                  enabledRadio : disabledRadio}
              />
              <span>Other</span>
            </div>
          </div>
        </div>
      </div>
      {!isEmpty(errorMessage) && <div className="error">{errorMessage}</div>}
      <button
        className="saveBtn"
        // eslint-disable-next-line no-unused-expressions
        disabled={!isEmpty(errorMessage)}
        onClick={() => { !isEmpty(selectedPatientToEdit) ? this.editPatient() : this.addPatient(); }}
      > Save </button>
    </div>);
  }

  render() {
    const { showAddPatientForm, addnewAddressView, showGenderPopup } = this.state;
    return (
      <div className="AddressPatientsWrapper">
        {!showAddPatientForm && !addnewAddressView && this.patientsContainerComp()}
        {showAddPatientForm && !addnewAddressView && this.addNewPatientComp()}
        {!showAddPatientForm && this.addressDetailsComp()}
        {showGenderPopup && (
        <PatientGenderCard
          selectedGender={this.props.selectedGender}
          onGenderSelect={this.handleGenderSelect}
          onClose={this.handleGenderPopupClose}
          onProceed={this.handleGenderSelectProceed}
        />
        )}
      </div>
    );
  }
}

DiagnosticsDeliveryAddress.propTypes = {
  patientsList: PropTypes.array,
  patientsLoading: PropTypes.bool,
  addresses: PropTypes.object,
  orderParams: PropTypes.object,
  actions: PropTypes.object.isRequired
};

DiagnosticsDeliveryAddress.defaultProps = {
  addresses: {},
  patientsLoading: false,
  orderParams: {},
  patientsList: [],
};

export default connect(state => ({
  selectedGender: state.patients.selectedGender,
  cartData: state.diagnosticsCart.data,
  orderParams: state.orderParams,
  addresses: state.address,
  selectedLab: state.diagnosticsCart.selectedLab,
  patientsList: state.patients.patientsList,
  patientsLoading: state.patients.loading,
  action: state.action,
}), dispatch => ({
  actions: bindActionCreators(actions, dispatch)
}))(DiagnosticsDeliveryAddress);
